import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=3edb7dce&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=3edb7dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb7dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edb7dce')) {
      api.createRecord('3edb7dce', component.options)
    } else {
      api.reload('3edb7dce', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=3edb7dce&scoped=true&", function () {
      api.rerender('3edb7dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UwaQmBcBT1Uj/JS/comp/GuestBox.vue"
export default component.exports